export enum ROUTER_PATHS {
    ROUND1 = '/round-1',
    ROUND2 = '/round-2',
    ROUND3 = '/round-3',
    RANKINGS = '/bang-xep-hang',
}
